export enum RedirectReason {
  APPLIED_WITHOUT_PRIMARY_TYPE = 'APPLIED_WITHOUT_PRIMARY_TYPE',
  APPLIED_TO_DIFFERENT_TYPE = 'APPLIED_TO_DIFFERENT_TYPE',
  LOGGED_IN_WITHOUT_PRIMARY_TYPE = 'LOGGED_IN_WITHOUT_PRIMARY_TYPE',
  LOGGED_IN_WITHOUT_PRIMARY_TYPE_AND_APPLY = 'LOGGED_IN_WITHOUT_PRIMARY_TYPE_AND_APPLY',
  APPLIED_WITHOUT_AN_ACCOUNT = 'APPLIED_WITHOUT_AN_ACCOUNT',
  APPLICATION_ALLOWED = 'APPLICATION_ALLOWED',
}
